import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { getBVIds } from './helpers'
import { setRatings } from './actions'
import isEqual from 'lodash/isEqual'

const withSetBVIdsToStore = lifecycle({
  componentDidMount() {
    this.props.setRatings({ bvIds: getBVIds(this.props) })
  },
  componentDidUpdate(prevProps) {
    const bvIds = getBVIds(this.props)

    if (!isEqual(bvIds, getBVIds(prevProps))) {
      this.props.setRatings({ bvIds })
    }
  }
})

export default compose(
  connect(null, { setRatings }),
  withSetBVIdsToStore
)
